import React, { FC } from 'react'
import { LoaderProps } from './Loader.interface'
import { Image, Spinner } from 'react-bootstrap'

import './Loader.styles.css'

export const Loader: FC<LoaderProps> = () => (
  <div className='loader-container'>
    <Image
      className='loader-logo'
      src='/Staidium_Logo.svg'
    />
    <Spinner color='#fff' />
  </div>
)

export const LoaderFullscreen: FC<LoaderProps> = props => (
  <div className='loader-fullscreen'>
    <Loader {...props} />
  </div>
)
